// extracted by mini-css-extract-plugin
export default {"titulo":"Titulo_titulo__sjyeA","linea":"Titulo_linea__1Mh5V"};